import parse from "html-react-parser";
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import isString from "lodash/isString";
import isArray from "lodash/isArray";

export const mdOpt = {
  html: true, // Enable HTML tags in source
  xhtmlOut: false,
  breaks: true,
  langPrefix: "language-",
  linkify: true,
  typographer: true,
  quotes: "“”‘’",
  highlight(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlightAuto(str).value;
        // eslint-disable-next-line no-empty
      } catch (__) {}
    }

    return "";
  },
};

const md = new MarkdownIt(mdOpt);

/**
 * 在 content 中找出該 word 的所有 index
 * @param text {string}
 * @param word {string}
 * @returns {*[]}
 */
const findAllIndex = (text, word) => {
  const data = [];
  if (!(text && isString(text))) return data;
  if (!(word && isString(word))) return data;
  let anchor = 0;
  const wordLen = word.length;
  const textLen = text.length;
  for (let i = 0; i < textLen; i += 1) {
    if (i >= anchor) {
      anchor = text.indexOf(word, anchor);
      if (anchor < 0) {
        // 可以結束搜尋
        break;
      } else {
        data.push({ word, index: anchor });
        anchor += wordLen;
      }
    }
  }
  return data;
};

/**
 * 在 content 中標記 keyword, 僅能標記一個 keyword
 * @param content {string}
 * @param keyword {string}
 * @param markStyle {string}
 * @returns {string|*}
 */
export const markKeyword = (content, keyword, markStyle) => {
  if (typeof content !== "string") return "";
  if (!(keyword && typeof keyword === "string")) return content;
  const split = content.split(keyword);
  // eslint-disable-next-line no-shadow
  const markKeyword = `<mark style="${markStyle}">${keyword}</mark>`;

  return md.render(split.join(markKeyword));
};

/**
 * 在 content 中標記 keyword, 可以標記一個到多個 keyword
 * @param content {string}
 * @param keywords {string | string[]}
 * @param markStyle {string}
 * @returns {string|*}
 */
export const markKeywords = (content, keywords, markStyle) => {
  if (!(content && isString(content))) return "";
  if (!((keywords && isString(keywords)) || isArray(keywords))) return content;
  const keywordList = isArray(keywords) ? [...keywords] : [keywords];

  if (keywordList.length === 0) return content;
  //
  const keywordsIndexSort = keywordList
    .reduce((acc, cur) => {
      const curKeywordIndex = findAllIndex(content, cur);
      return acc.concat(curKeywordIndex);
    }, [])
    .sort((a, b) => a.index - b.index);

  let markStr = "";
  let anchor = 0;
  keywordsIndexSort.forEach(({ word, index }) => {
    if (anchor >= content.length) return;
    markStr += content.substring(anchor, index);
    markStr += `<mark style="${markStyle}">${word}</mark>`;
    anchor = index + word.length;
  });
  return markStr;
};
